import React from "react";
import {
  FaCode,
  FaMobileAlt,
  FaCube,
  FaPaintBrush,
  FaCloud,
  FaShieldAlt
} from "react-icons/fa";

const services = [
  {
    icon: <FaCode />,
    title: "Web Development",
    desc:
      "High-performance, responsive, and SEO-friendly websites using modern technologies."
  },
  {
    icon: <FaMobileAlt />,
    title: "Mobile App Development",
    desc:
      "Custom Android and iOS mobile applications built for scalability and performance."
  },
  {
    icon: <FaCube />,
    title: "Blockchain Solutions",
    desc:
      "Secure blockchain development including smart contracts and decentralized apps."
  },
  {
    icon: <FaPaintBrush />,
    title: "UI / UX & Branding",
    desc:
      "Creative UI/UX designs and branding solutions that enhance user engagement."
  },
  {
    icon: <FaCloud />,
    title: "Cloud & DevOps",
    desc:
      "Cloud deployment, CI/CD pipelines, and scalable infrastructure solutions."
  },
  {
    icon: <FaShieldAlt />,
    title: "Security & Maintenance",
    desc:
      "Website security, optimization, updates, and long-term technical support."
  }
];

const Services = () => {
  return (
    <section id="services">
      <h2>Our Services</h2>

      <p>
        We provide a wide range of IT services designed to help businesses
        innovate, scale, and succeed in a competitive digital landscape.
      </p>

      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
